import Main from "../../../pages/Main";
import React from "react";
import AboutUs from "../../../pages/AboutUs";
import UnderConstruction from "../../../pages/UnderConstruction";

export default function TermsPage() {
    return <UnderConstruction />;
}
